export const MUNILY_QTY_STEPPER_DEFAULTS = {
  value: 1,
  min: 1,
  max: 99,
  disabled: false,
} as const;
